import { ObjectId } from 'mongodb'
import { Builder } from '../internal/builder'
import { ApiReferenceGuideVersionSchema, DocumentationGuideVersionSchema } from './docs-project'

export class DocumentationGuideVersionSchemaBuilder extends Builder<DocumentationGuideVersionSchema> {
	setDefaults() {
		return {
			id: new ObjectId(),
			variant: 'GUIDE',
			status: 'STABLE',
			slug: 'slug',
			name: 'name',
			visibility: 'PUBLIC',
			sidebarItems: [],
			isDefault: true,
			createdAt: new Date(),
		} satisfies DocumentationGuideVersionSchema
	}
}

export class DocumentationApiReferenceGuideVersionSchemaBuilder extends Builder<ApiReferenceGuideVersionSchema> {
	setDefaults() {
		return {
			id: new ObjectId(),
			variant: 'API_REFERENCE',
			status: 'STABLE',
			slug: 'slug',
			name: 'name',
			visibility: 'PUBLIC',
			url: 'https://example.com/api-reference.json',
			isDefault: true,
			createdAt: new Date(),
		} satisfies ApiReferenceGuideVersionSchema
	}
}
